import React from 'react';
import { MenuItem, Select, Typography } from '@mui/material';

const LOCATOR_TYPE_OPTIONS = [
  { value: 'id', label: 'ID' },
  { value: 'xpath', label: 'XPATH' },
  { value: 'accessibility id', label: 'ACCESSIBILITY_ID' },
  { value: 'link text', label: 'LINK_TEXT' },
  { value: 'partial link text', label: 'PARTIAL_LINK_TEXT' },
  { value: 'name', label: 'NAME' },
  { value: 'tag name', label: 'TAG_NAME' },
  { value: 'class name', label: 'CLASS_NAME' },
  { value: 'css selector', label: 'CSS_SELECTOR' },
  { value: '-ios predicate string', label: 'IOS_PREDICATE' },
  { value: '-ios uiautomation', label: 'IOS_UIAUTOMATION' },
  { value: '-ios class chain', label: 'IOS_CLASS_CHAIN' },
  { value: '-android uiautomator', label: 'ANDROID_UIAUTOMATOR' },
  { value: '-android viewtag', label: 'ANDROID_VIEWTAG' },
  { value: '-android datamatcher', label: 'ANDROID_DATA_MATCHER' },
  { value: '-android viewmatcher', label: 'ANDROID_VIEW_MATCHER' },
  { value: '-windows uiautomation', label: 'WINDOWS_UI_AUTOMATION' },
  { value: '-image', label: 'IMAGE' },
  { value: '-custom', label: 'CUSTOM' },
];

export default function LocatorTypeSelect({ error, sx, ...field }) {
  return (
    <>
      <Select size="small" displayEmpty sx={sx} {...field} error={Boolean(error)}>
        <MenuItem value="" disabled>
          Select locator type
        </MenuItem>
        {LOCATOR_TYPE_OPTIONS.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
      {error && (
        <Typography variant="caption" color="error">
          {error.message}
        </Typography>
      )}
    </>
  );
}
